import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { hasAnalyticsCookieConsent } from "./CookieConsent";

/**
 * PostHog consent handler - manages opt-in/opt-out based on cookie consent
 * The actual PostHog initialization is handled by PostHogProvider in main.tsx
 */
export const PostHogConsentHandler = ({ children }: { children: React.ReactNode }) => {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    // Set initial consent state
    if (hasAnalyticsCookieConsent()) {
      posthog.opt_in_capturing();
    } else {
      posthog.opt_out_capturing();
    }

    // Listen for cookie consent changes
    const handleConsentUpdate = (event: CustomEvent<{ analytics: boolean }>) => {
      if (event.detail.analytics) {
        posthog.opt_in_capturing();
      } else {
        posthog.opt_out_capturing();
      }
    };

    window.addEventListener("cookie-consent-updated", handleConsentUpdate as EventListener);
    return () => {
      window.removeEventListener("cookie-consent-updated", handleConsentUpdate as EventListener);
    };
  }, [posthog]);

  return <>{children}</>;
};

export default PostHogConsentHandler;
